import { render, staticRenderFns } from "./createPerfil.vue?vue&type=template&id=079893a3&scoped=true"
import script from "./createPerfil.vue?vue&type=script&lang=js"
export * from "./createPerfil.vue?vue&type=script&lang=js"
import style0 from "./createPerfil.vue?vue&type=style&index=0&id=079893a3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "079893a3",
  null
  
)

export default component.exports